//
//
//
//
//
//

import Tabbars from '@/components/tabbar'
import { mapActions } from 'vuex'
// import { getRequest } from '@/assets/scripts/utils'
export default {
  name: 'app',
  components: {
    Tabbars
  },
  data () {
    return {
      tabbar: [
        {
          'label': '首页',
          'icon': 'icon-home',
          'href': '/home'
        },
        {
          'label': '办理记录',
          'icon': 'icon-record',
          'href': '/record'
        },
        {
          'label': '通知',
          'icon': 'icon-notice',
          'href': '/notice'
        },
        {
          'label': '我的',
          'icon': 'icon-mine',
          'href': '/user'
        }
      ]

    }
  },
  mounted () {
    this.getAppType()
  },
  methods: {
    ...mapActions(['LoginAction', 'userInfoAction']),
    // 判断程序运行app类型--微信/学付宝
    getAppType () {
      var wx = navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
      // let token = JSON.stringify(getRequest(window.location.href)) !== '{}' ? getRequest(window.location.href).info : null
      if (!wx) {
        this.client()
      }
    },
    // 学付宝--获取客户端类型，引入不同的js
    client () {
      const oScript = document.createElement('script')
      oScript.type = 'text/javascript'
      const u = navigator.userAgent
      const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
      if (isAndroid) {
        oScript.src = './static/scripts/cordova/android_cordova.js'
      } else {
        oScript.src = './static/scripts/cordova/ios_cordova.js'
        // document.body.appendChild(oScript)
        // const script1 = document.createElement('script')
        // script1.setAttribute('type', 'text/javascript')
        // script1.setAttribute('src', './static/scripts/cordova/cordova_plugins.js')
        // document.body.appendChild(script1)
      }
      document.body.appendChild(oScript)
      const script1 = document.createElement('script')
      script1.setAttribute('type', 'text/javascript')
      script1.setAttribute('src', './static/scripts/cordova/cordova_plugins.js')
      document.body.appendChild(script1)
    }
  }
}



// WEBPACK FOOTER //
// ./src/yingxin/tskjxy/App.vue